var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _g, _g2, _g3, _path12, _g4, _path13, _path14, _g5, _g6, _g7, _g8, _g9, _g10, _rect2, _rect3, _rect4, _rect5, _ellipse, _ellipse2, _circle, _path15, _g11, _g12, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4385_28150)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2014 57.5919C19.223 60.8856 25.2295 62.8012 31.6835 62.8012C39.7931 62.8012 47.1964 59.7766 52.8268 54.794L53.6366 53.9445C54.9793 52.5783 55.733 50.7411 55.6859 48.8096L55.7095 27.6808C55.6859 26.5737 54.7673 25.6551 53.6366 25.6786H53.5895H32.6021C30.6941 25.6315 28.8333 25.9142 27.4907 27.2804L15.9488 38.9165C14.6061 40.2827 13.8524 42.1435 13.8995 44.0515L14.2014 57.5919Z",
    fill: "#3388FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.76244 30.3481C-3.43406 32.7187 -2.76477 34.9797 -1.80593 37.0796L15.1728 37.4504C16.7419 37.4862 18.2574 36.8773 19.3629 35.7489L28.4561 26.1489C29.5615 25.0205 30.1677 23.4802 30.1321 21.9041L30.1499 4.47717C30.1499 3.56374 29.3832 2.82941 28.4739 2.82941H28.4382H10.4123C8.84325 2.79358 7.95176 3.04433 6.70367 4.13687L-2.46086 13.7369C-3.56631 14.8474 -3.81593 16.3877 -3.76244 17.9817V30.3481Z",
    fill: "#3388FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.542805 32.508C0.0729141 48.9506 13.3563 62.155 29.8371 62.6561L59.7516 32.24C61.3029 30.6895 62.1364 28.5837 62.0901 26.3853L62.1133 2.29514C62.0901 1.02237 61.0482 0.00414981 59.7747 0.00414981H59.7052H35.7638C33.5873 -0.0421328 31.4803 0.281846 29.929 1.83231L-0.542805 32.508Z",
    fill: "#1760CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4385_28150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 67,
    height: 63
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1315 1.63989L6.214 1.63989C5.63023 1.63989 4.11921 2.12618 4.09817 3.93008V6.86736L-2.46023 13.7374C-3.56568 14.8479 -3.8153 16.3882 -3.76182 17.9822V30.3486C-3.43344 32.7192 -2.76415 34.9803 -1.80531 37.0802L-0.0282447 37.119C2.42238 50.2047 13.0056 60.4273 26.2778 62.3462C28.035 62.646 29.8411 62.8021 31.6837 62.8021C39.7934 62.8021 47.1966 59.7775 52.827 54.7949L53.6369 53.9455C54.9795 52.5793 55.7332 50.742 55.6861 48.8105L55.7 36.3598L59.7519 32.24C61.3033 30.6895 62.1368 28.5837 62.0905 26.3853L62.1136 2.29514C62.0905 1.02237 61.0486 0.00414981 59.7751 0.00414981H59.7056H35.7642C33.6808 -0.0401518 31.6612 0.254789 30.1315 1.63989Z",
    fill: "#1760CE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4385_28150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4385_28150)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4525 47.4219H36.0253L37.3588 54.4702H22.3096L23.4525 47.4219Z",
    fill: "#9DA5B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.143 7.92578H2.59789C1.17629 7.92578 0.0214844 9.07707 0.0214844 10.4962V44.964C0.0214844 46.3844 1.17629 47.5344 2.59789 47.5344H23.2387H56.1417C57.5658 47.5344 58.7194 46.3844 58.7194 44.964V10.4962C58.7194 9.07707 57.5658 7.92578 56.143 7.92578Z",
    fill: "#212933"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6436 10.541H3.16699V41.7043H55.6436V10.541Z",
    fill: "#FAFBFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6094 10.4956L3.13278 41.6602L3.13278 10.4955L55.6094 10.4956Z",
    fill: "#D8DDE1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7193 44.9632V44.2305H0.0214844V44.9632C0.0214844 46.3837 1.17629 47.5337 2.59789 47.5337H23.2387H35.3436H56.1417C57.5658 47.5349 58.7193 46.3837 58.7193 44.9632Z",
    fill: "#D8DDE1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.9761,
    y: 54.4688,
    width: 17.7161,
    height: 2.28595,
    fill: "#D8DDE1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4385_28150)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8808 11.418H14.5948C14.437 11.418 14.3091 11.5459 14.3091 11.7037C14.3091 11.8615 14.437 11.9895 14.5948 11.9895H16.8808C17.0386 11.9895 17.1665 11.8615 17.1665 11.7037C17.1665 11.5459 17.0386 11.418 16.8808 11.418Z",
    fill: "#9DA7B1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.1328H14.8806C14.5649 13.1328 14.3091 13.3887 14.3091 13.7043C14.3091 14.0199 14.5649 14.2758 14.8806 14.2758H18.5C18.8156 14.2758 19.0715 14.0199 19.0715 13.7043C19.0715 13.3887 18.8156 13.1328 18.5 13.1328Z",
    fill: "#9DA7B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 10.4648,
    width: 9.90579,
    height: 31.2413,
    fill: "#323E49"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.90579,
    height: 2.35368,
    transform: "translate(3.06982 39.3535)",
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30572 39.6113H5.41969C5.47096 39.6113 5.51252 39.6531 5.51252 39.7045V40.823C5.51252 40.8745 5.47096 40.9162 5.41969 40.9162H4.30572C4.25445 40.9162 4.21289 40.8745 4.21289 40.823V39.7045C4.21289 39.6531 4.25445 39.6113 4.30572 39.6113ZM5.01556 40.1757L4.61252 40.5804C4.60558 40.5879 4.60574 40.5996 4.613 40.6069L4.6149 40.6086C4.7343 40.7128 4.9154 40.7079 5.02898 40.5938C5.14316 40.4792 5.1475 40.296 5.042 40.1762C5.0347 40.1689 5.023 40.1687 5.01556 40.1757ZM4.70985 40.3517L4.70984 40.3517C4.7024 40.3587 4.6907 40.3585 4.68344 40.3512L4.6834 40.3513C4.5779 40.2314 4.58224 40.0482 4.69642 39.9336C4.81 39.8195 4.9911 39.8146 5.1105 39.9188L5.1124 39.9205C5.11966 39.9278 5.11982 39.9395 5.11287 39.947L5.11288 39.947L4.70985 40.3517ZM5.93635 40.3926C5.95028 40.3926 5.96457 40.4004 5.97658 40.4144C5.99911 40.4422 6.03327 40.4464 6.0515 40.4464C6.11115 40.4464 6.14237 40.4124 6.14237 40.3788C6.14237 40.3329 6.09518 40.3144 6.04056 40.2931L6.04017 40.2929C5.97206 40.2661 5.88741 40.2328 5.88741 40.1289C5.88741 40.0279 5.97315 39.9749 6.05794 39.9749C6.11945 39.9749 6.18433 40.0089 6.21575 40.0577C6.22107 40.0656 6.22385 40.0754 6.22385 40.086C6.22385 40.1137 6.19978 40.1371 6.17133 40.1371C6.15632 40.1371 6.14266 40.1289 6.13087 40.1131C6.11308 40.0881 6.08785 40.0749 6.05794 40.0749C6.0102 40.0749 5.98885 40.1021 5.98885 40.1289C5.98885 40.1625 6.02366 40.1779 6.08043 40.2004L6.08071 40.2005C6.15346 40.2294 6.24381 40.2652 6.24381 40.3788C6.24381 40.4878 6.14477 40.5466 6.0515 40.5466C5.99703 40.5466 5.92534 40.5216 5.89372 40.4738C5.88714 40.4643 5.88377 40.4542 5.88377 40.4435C5.88377 40.4169 5.90883 40.3926 5.93635 40.3926ZM8.33644 40.1508C8.33644 40.0509 8.26014 39.9749 8.16009 39.9749H8.1572C8.05714 39.9749 7.97667 40.056 7.97667 40.1558V40.3655L7.97654 40.3715C7.9764 40.3756 7.97627 40.3796 7.97667 40.3836V40.7822C7.97667 40.8099 7.99922 40.8324 8.02705 40.8324C8.05486 40.8324 8.07742 40.8099 8.07742 40.7822V40.5213C8.09657 40.5383 8.12852 40.5464 8.1572 40.5464H8.16009C8.26014 40.5464 8.33644 40.4601 8.33644 40.3603V40.1508ZM8.23824 40.3654V40.1557C8.23824 40.1126 8.20318 40.0777 8.15996 40.0777H8.15707C8.11386 40.0777 8.07875 40.1126 8.07875 40.1557V40.3654C8.07875 40.42 8.11386 40.4434 8.15707 40.4434H8.15996C8.20318 40.4434 8.23824 40.42 8.23824 40.3654ZM7.87593 40.0229H7.87566C7.87441 39.9962 7.8524 39.9749 7.82515 39.9749C7.79786 39.9749 7.77592 39.9962 7.77466 40.0229H7.77435V40.3693C7.77435 40.4115 7.73981 40.4457 7.69736 40.4457H7.69448C7.65186 40.4457 7.6174 40.4115 7.6174 40.3693V40.0263L7.61753 40.0253L7.6174 40.0242V40.0229H7.61732C7.61606 39.9962 7.59398 39.9749 7.56677 39.9749C7.53957 39.9749 7.51754 39.9962 7.51628 40.0229H7.51589V40.3693C7.51589 40.4669 7.59598 40.5466 7.69448 40.5466H7.69736C7.79577 40.5466 7.87593 40.4669 7.87593 40.3693V40.0229ZM6.68744 40.0229H6.68766V40.3693C6.68766 40.4669 6.60756 40.5466 6.50901 40.5466H6.50623C6.40777 40.5466 6.32762 40.4669 6.32762 40.3693V40.0229H6.32802C6.32927 39.9962 6.35131 39.9749 6.3786 39.9749C6.40573 39.9749 6.42778 39.9962 6.42908 40.0229H6.42922V40.0242L6.42926 40.0253L6.42922 40.0263V40.3693C6.42922 40.4115 6.46373 40.4457 6.50623 40.4457H6.50901C6.5516 40.4457 6.58613 40.4115 6.58613 40.3693V40.0229H6.58639C6.58765 39.9962 6.60969 39.9749 6.6369 39.9749C6.66415 39.9749 6.68618 39.9962 6.68744 40.0229ZM7.40768 40.1521C7.40768 40.0543 7.32842 39.9749 7.23107 39.9749H7.22828C7.17875 39.9749 7.13403 39.9955 7.10192 40.0286C7.06983 39.9957 7.02521 39.9752 6.97578 39.9752H6.97302C6.87567 39.9752 6.79646 40.0546 6.79646 40.1524V40.4985H6.79671C6.79791 40.5253 6.81969 40.5466 6.84664 40.5466C6.87357 40.5466 6.89535 40.5253 6.89656 40.4985H6.89686V40.1524C6.89686 40.1101 6.93093 40.0759 6.97302 40.0759H6.97578C7.01679 40.0759 7.05009 40.1084 7.05185 40.1491L7.05167 40.1521V40.4982H7.05194C7.05238 40.5083 7.05578 40.5176 7.06124 40.5253C7.0703 40.5381 7.08517 40.5466 7.10213 40.5466C7.12905 40.5466 7.15082 40.5253 7.15207 40.4985H7.15242V40.1524L7.15229 40.149C7.15387 40.1082 7.18726 40.0756 7.22828 40.0756H7.23107C7.27318 40.0756 7.30724 40.1098 7.30724 40.1521V40.4949L7.30715 40.4959L7.30724 40.497V40.4982H7.30741C7.30862 40.5249 7.33035 40.5463 7.35733 40.5463C7.38427 40.5463 7.40601 40.5249 7.40725 40.4982H7.40768V40.1521ZM8.57095 39.9749C8.62638 39.9749 8.67142 40.0202 8.67142 40.0758C8.67142 40.1315 8.62638 40.1767 8.57095 40.1767C8.51552 40.1767 8.47047 40.1315 8.47047 40.0758C8.47047 40.0202 8.51552 39.9749 8.57095 39.9749ZM8.64704 40.0757C8.64704 40.1178 8.61289 40.1522 8.57094 40.1522C8.52903 40.1522 8.49481 40.1178 8.49481 40.0757C8.49481 40.0337 8.52903 39.9996 8.57094 39.9996C8.61289 39.9996 8.64704 40.0337 8.64704 40.0757ZM8.53742 40.0356C8.53742 40.029 8.54246 40.0252 8.54779 40.0252H8.57278C8.59121 40.0252 8.60327 40.0366 8.60327 40.0537C8.60327 40.0672 8.59499 40.077 8.58202 40.0794L8.60007 40.099C8.60289 40.1021 8.6044 40.1045 8.6044 40.108C8.6044 40.111 8.60176 40.1177 8.59377 40.1177C8.58844 40.1177 8.58655 40.1158 8.58395 40.1125L8.5585 40.0802H8.55821V40.1065C8.55821 40.1139 8.55384 40.1177 8.54779 40.1177C8.54183 40.1177 8.53742 40.1139 8.53742 40.1065V40.0356ZM8.57189 40.0647H8.55824V40.0444H8.57189C8.57777 40.0444 8.5826 40.0481 8.5826 40.0544C8.5826 40.0601 8.5787 40.0647 8.57189 40.0647Z",
    fill: "#FAFBFC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 10.4648,
    width: 9.9296,
    height: 2.9421,
    fill: "#0F131A"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39373 12.6722C4.79995 12.6722 5.12926 12.3429 5.12926 11.9367C5.12926 11.5305 4.79995 11.2012 4.39373 11.2012C3.98751 11.2012 3.6582 11.5305 3.6582 11.9367C3.6582 12.3429 3.98751 12.6722 4.39373 12.6722Z",
    fill: "#3388FF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 14.2754,
    width: 9.88204,
    height: 2.28595,
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 15.7991C4.4192 15.7991 4.59023 15.6276 4.59023 15.4181C4.59023 15.2086 4.4192 15.0371 4.21016 15.0371C4.00111 15.0371 3.83008 15.2086 3.83008 15.4181C3.83008 15.6276 4.00111 15.7991 4.21016 15.7991Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8609 15.0371H5.54164C5.33122 15.0371 5.16064 15.2077 5.16064 15.4181C5.16064 15.6285 5.33122 15.7991 5.54164 15.7991H10.8609C11.0713 15.7991 11.2419 15.6285 11.2419 15.4181C11.2419 15.2077 11.0713 15.0371 10.8609 15.0371Z",
    fill: "#D8DDE1"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3618 11.2285H6.05288C5.87832 11.2285 5.73682 11.37 5.73682 11.5446C5.73682 11.7191 5.87832 11.8606 6.05288 11.8606H10.3618C10.5363 11.8606 10.6778 11.7191 10.6778 11.5446C10.6778 11.37 10.5363 11.2285 10.3618 11.2285Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22153 12.0176H6.05288C5.87832 12.0176 5.73682 12.1591 5.73682 12.3336C5.73682 12.5082 5.87832 12.6497 6.05288 12.6497H9.22153C9.39609 12.6497 9.5376 12.5082 9.5376 12.3336C9.5376 12.1591 9.39609 12.0176 9.22153 12.0176Z",
    fill: "#9DA7B1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 16.9434,
    width: 9.88204,
    height: 2.28595,
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 18.4671C4.4192 18.4671 4.59023 18.2956 4.59023 18.0861C4.59023 17.8765 4.4192 17.7051 4.21016 17.7051C4.00111 17.7051 3.83008 17.8765 3.83008 18.0861C3.83008 18.2956 4.00111 18.4671 4.21016 18.4671Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8604 17.7051H5.54115C5.33073 17.7051 5.16016 17.8757 5.16016 18.0861C5.16016 18.2965 5.33073 18.4671 5.54115 18.4671H10.8604C11.0708 18.4671 11.2414 18.2965 11.2414 18.0861C11.2414 17.8757 11.0708 17.7051 10.8604 17.7051Z",
    fill: "#D8DDE1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 19.6094,
    width: 9.88204,
    height: 2.28595,
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 21.1331C4.4192 21.1331 4.59023 20.9616 4.59023 20.7521C4.59023 20.5425 4.4192 20.3711 4.21016 20.3711C4.00111 20.3711 3.83008 20.5425 3.83008 20.7521C3.83008 20.9616 4.00111 21.1331 4.21016 21.1331Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8609 20.3711H5.54164C5.33122 20.3711 5.16064 20.5417 5.16064 20.7521C5.16064 20.9625 5.33122 21.1331 5.54164 21.1331H10.8609C11.0713 21.1331 11.2419 20.9625 11.2419 20.7521C11.2419 20.5417 11.0713 20.3711 10.8609 20.3711Z",
    fill: "#D8DDE1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 22.2754,
    width: 9.88204,
    height: 2.28595,
    fill: "#212933"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 22.2754,
    width: 9.90579,
    height: 2.28595,
    fill: "#0F131A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 23.801C4.4192 23.801 4.59023 23.6296 4.59023 23.4201C4.59023 23.2105 4.4192 23.0391 4.21016 23.0391C4.00111 23.0391 3.83008 23.2105 3.83008 23.4201C3.83008 23.6296 4.00111 23.801 4.21016 23.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8604 23.0391H5.54115C5.33073 23.0391 5.16016 23.2096 5.16016 23.4201C5.16016 23.6305 5.33073 23.801 5.54115 23.801H10.8604C11.0708 23.801 11.2414 23.6305 11.2414 23.4201C11.2414 23.2096 11.0708 23.0391 10.8604 23.0391Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 24.9434,
    width: 9.88204,
    height: 2.28595,
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 26.4671C4.4192 26.4671 4.59023 26.2956 4.59023 26.0861C4.59023 25.8765 4.4192 25.7051 4.21016 25.7051C4.00111 25.7051 3.83008 25.8765 3.83008 26.0861C3.83008 26.2956 4.00111 26.4671 4.21016 26.4671Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8609 25.7051H5.54164C5.33122 25.7051 5.16064 25.8757 5.16064 26.0861C5.16064 26.2965 5.33122 26.4671 5.54164 26.4671H10.8609C11.0713 26.4671 11.2419 26.2965 11.2419 26.0861C11.2419 25.8757 11.0713 25.7051 10.8609 25.7051Z",
    fill: "#D8DDE1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 27.6094,
    width: 9.88204,
    height: 2.28595,
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 29.135C4.4192 29.135 4.59023 28.9636 4.59023 28.754C4.59023 28.5445 4.4192 28.373 4.21016 28.373C4.00111 28.373 3.83008 28.5445 3.83008 28.754C3.83008 28.9636 4.00111 29.135 4.21016 29.135Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8604 28.373H5.54115C5.33073 28.373 5.16016 28.5436 5.16016 28.754C5.16016 28.9645 5.33073 29.135 5.54115 29.135H10.8604C11.0708 29.135 11.2414 28.9645 11.2414 28.754C11.2414 28.5436 11.0708 28.373 10.8604 28.373Z",
    fill: "#D8DDE1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_4385_28150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.06982,
    y: 30.2773,
    width: 9.88204,
    height: 2.28595,
    fill: "#323E49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21016 31.801C4.4192 31.801 4.59023 31.6296 4.59023 31.4201C4.59023 31.2105 4.4192 31.0391 4.21016 31.0391C4.00111 31.0391 3.83008 31.2105 3.83008 31.4201C3.83008 31.6296 4.00111 31.801 4.21016 31.801Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8609 31.0391H5.54164C5.33122 31.0391 5.16064 31.2096 5.16064 31.4201C5.16064 31.6305 5.33122 31.801 5.54164 31.801H10.8609C11.0713 31.801 11.2419 31.6305 11.2419 31.4201C11.2419 31.2096 11.0713 31.0391 10.8609 31.0391Z",
    fill: "#D8DDE1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3091,
    y: 15.418,
    width: 7.23885,
    height: 2.28595,
    rx: 0.399572,
    fill: "#3388FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5503,
    y: 15.418,
    width: 5.71488,
    height: 2.28595,
    rx: 0.399572,
    fill: "#D8DDE1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6924,
    y: 15.418,
    width: 5.71488,
    height: 2.28595,
    rx: 0.399572,
    fill: "#D8DDE1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8345,
    y: 15.418,
    width: 5.71488,
    height: 2.28595,
    rx: 0.399572,
    fill: "#D8DDE1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5512,
    cy: 15.6739,
    rx: 0.253995,
    ry: 0.253995,
    transform: "rotate(90 53.5512 15.6739)",
    fill: "#212933"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5512,
    cy: 16.5626,
    rx: 0.253995,
    ry: 0.253995,
    transform: "rotate(90 53.5512 16.5626)",
    fill: "#212933"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5512,
    cy: 17.4513,
    r: 0.253995,
    transform: "rotate(90 53.5512 17.4513)",
    fill: "#212933"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_4385_28150)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4385_28150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 19,
    width: 36,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0744 19.418H12.9756V41.706H47.0744V19.418Z",
    fill: "#FAFBFC"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4385_28150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4385_28150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9828 48.5417H21.9975C21.6438 48.5417 21.3574 48.2361 21.3574 47.8589V20.8001C21.3574 20.4228 21.6438 20.1172 21.9975 20.1172H43.9828C44.3364 20.1172 44.6228 20.4228 44.6228 20.8001V47.8589C44.6228 48.2361 44.3364 48.5417 43.9828 48.5417Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.9828 20.1172H21.9975C21.6438 20.1172 21.3574 20.4228 21.3574 20.8001V25.3029H44.6228V20.8001C44.6228 20.4228 44.3364 20.1172 43.9828 20.1172Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.637 34.8789H39.5806V35.6558H42.637V34.8789Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.637 37.5977H39.5806V38.3745H42.637V37.5977Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6371 22.4473H36.1421V23.2241H42.6371V22.4473Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6371 27.1094H36.1421V27.8862H42.6371V27.1094Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0292 27.1094H23.5342V27.8862H30.0292V27.1094Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0292 29.8281H23.5342V30.605H30.0292V29.8281Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 34.8789H23.5342V35.6558H36.9062V34.8789Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9395 37.5977H23.5342V38.3745H31.9395V37.5977Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.637 40.3164H39.5806V41.0933H42.637V40.3164Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2318 40.3164H23.5342V41.0933H34.2318V40.3164Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M44.1523 48.613C44.5114 48.613 44.8022 48.3063 44.8022 47.9277V20.7713C44.8022 20.3927 44.5114 20.086 44.1523 20.086L32.9902 20.0859V48.613C36.7109 48.613 40.4316 48.613 44.1523 48.613Z",
    fill: "black"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_4385_28150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7861 24.1181C25.5195 24.1181 26.1196 23.5181 26.1196 22.7846C26.1196 22.0512 25.5195 21.4512 24.7861 21.4512C24.0527 21.4512 23.4526 22.0512 23.4526 22.7846C23.4526 23.5181 24.0527 24.1181 24.7861 24.1181Z",
    fill: "#212933"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4172 22.3468C25.5914 22.513 25.5914 22.7826 25.4172 22.9488L24.7909 23.5464L24.1546 22.9394C23.9804 22.7732 23.9804 22.5035 24.1546 22.3373C24.3285 22.1714 24.6103 22.1714 24.7842 22.3373L24.7909 22.3437C24.9651 22.1809 25.2444 22.1819 25.4172 22.3468Z",
    fill: "#9DA7B1"
  })))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.9707 48.2227C40.431 46.5824 44.3675 42.7279 44.3675 42.7279",
    stroke: "#AFD0FE",
    strokeWidth: 0.235549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.94 0.94"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.6482 37.3154C12.3836 44.1222 12.8757 62.4106 22.3889 56.9979",
    stroke: "#AFD0FE",
    strokeWidth: 0.235549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.94 0.94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4385_28150",
    x: -1.97872,
    y: 7.92578,
    width: 60.698,
    height: 50.1616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.00021,
    dy: 1.33347
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_28150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4385_28150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_4385_28150",
    x: 2.92272,
    y: 10.4648,
    width: 10.2,
    height: 31.5364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.147105
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0735526
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0588235 0 0 0 0 0.0784314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_28150"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0735526
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0367763
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0588235 0 0 0 0 0.0784314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4385_28150",
    result: "effect2_dropShadow_4385_28150"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0588235 0 0 0 0 0.0784314 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4385_28150",
    result: "effect3_dropShadow_4385_28150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_4385_28150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4385_28150",
    x: 3.06982,
    y: 10.4648,
    width: 9.92969,
    height: 2.97818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0367763
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.13 0 0 0 0 0.1615 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_28150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4385_28150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4385_28150",
    x: 20.7043,
    y: 20.1172,
    width: 23.9188,
    height: 29.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.653129,
    dy: 0.653129
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_28150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4385_28150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62.6561,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.0054,
    height: 31.2413,
    fill: "white",
    transform: "translate(3.06934 10.4648)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.90579,
    height: 2.35368,
    fill: "white",
    transform: "translate(3.06982 39.3535)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 14.2754)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 16.9434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 19.6094)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 22.2754)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 24.9434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 27.6094)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.88204,
    height: 2.28595,
    fill: "white",
    transform: "translate(3.06982 30.2773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.0988,
    height: 22.288,
    fill: "white",
    transform: "translate(12.9756 19.418)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_4385_28150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.66694,
    height: 2.66694,
    fill: "white",
    transform: "translate(23.4526 21.4512)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.d087da91.svg";
export { ForwardRef as ReactComponent };